import { useEffect, useMemo, useState } from 'react';
import { Carousel, Col } from 'react-bootstrap';
import { getHomeCarouselImages } from '../../controllers/homeCarousel';

function HomeCarousel() {
  const [images, setImages] = useState([]);

  useEffect(() => {
    let mounted = true;

    async function loadImages() {
      try {
        const data = await getHomeCarouselImages();
        if (mounted) setImages(data || []);
      } catch (_) {
        if (mounted) setImages([]);
      }
    }

    loadImages();
    return () => { mounted = false; };
  }, []);

  const imageUrls = useMemo(() => {
    if (images.length) return images.map(image => image.url);
    return ['/home/home-1.jpg'];
  }, [images]);

  const mainImageUrl = imageUrls[0];

  return <>
    <Carousel controls={imageUrls.length > 1} indicators={imageUrls.length > 1} className="d-none d-sm-none d-md-block">
      {imageUrls.map((imageUrl, index) => (
        <Carousel.Item key={`home-carousel-image-${index}`}>
          <div className="carousel-image" style={{
            backgroundImage: `url(${imageUrl})`
          }}></div>
          <Carousel.Caption>
            <h5>Quiénes somos</h5>
            <p>Somos una organización católica de laicos, asistidos por asesores espirituales, que fomenta la espiritualidad conyugal y el apostolado familiar, inspirada por los valores del evangelio.</p>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
    <div className="d-block d-md-none mision somos">
      <div>
        <div className="image" style={{
            backgroundImage: `url(${mainImageUrl})`
          }}></div>
        <Col>
          <h5>Quiénes somos</h5>
          <p>Somos una organización católica de laicos, asistidos por asesores espirituales, que fomenta la espiritualidad conyugal y el apostolado familiar, inspirada por los valores del evangelio.</p>
        </Col>
      </div>
    </div>
  </>;
}

export default HomeCarousel;